[
  {
    "id": "batteri.soc",
    "signalk": "electrical.batteries.*.capacity.stateOfCharge",
    "enhet": "%",
    "beskrivning": "Batteriets laddning",
    "min": 0,
    "max": 100
  },
  {
    "id": "batteri.spanning",
    "signalk": "electrical.batteries.*.voltage",
    "enhet": "V",
    "beskrivning": "Batteriets spänning",
    "min": 0,
    "max": 60
  },
  {
    "id": "batteri.strom",
    "signalk": "electrical.batteries.*.current",
    "enhet": "A",
    "beskrivning": "Batteriets ström",
    "min": -1000,
    "max": 1000
  },
  {
    "id": "batteri.temp",
    "signalk": "electrical.batteries.*.temperature",
    "enhet": "°C",
    "beskrivning": "Batteriets temperatur",
    "min": -40,
    "max": 80
  },
  {
    "id": "landstrom.finns",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Landströmmen finns",
    "min": null,
    "max": null
  },
  {
    "id": "landstrom.spanning",
    "signalk": "electrical.ac.*.phase.A.lineNeutralVoltage",
    "enhet": "V",
    "beskrivning": "Landströmmens spänning",
    "min": 0,
    "max": 300
  },
  {
    "id": "laddare.lage",
    "signalk": "electrical.chargers.*.chargingMode",
    "enhet": "",
    "beskrivning": "Laddarens läge",
    "min": null,
    "max": null
  },
  {
    "id": "laddare.strom",
    "signalk": "electrical.chargers.*.current",
    "enhet": "A",
    "beskrivning": "Laddarens ström",
    "min": 0,
    "max": 500
  },
  {
    "id": "vaxelriktare.pa",
    "signalk": "electrical.inverters.*.inverterMode",
    "enhet": "",
    "beskrivning": "Växelriktaren är på",
    "min": null,
    "max": null
  },
  {
    "id": "generator.gar",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Generatorn går (generatoringången i Mass Combi)",
    "min": null,
    "max": null,
    "gang": true
  },
  {
    "id": "forbrukare.gar",
    "signalk": null,
    "enhet": "",
    "beskrivning": "En förbrukare går, till exempel värmaren",
    "min": null,
    "max": null,
    "gang": true
  },
  {
    "id": "position",
    "signalk": "navigation.position",
    "enhet": "lat/lon",
    "beskrivning": "Positionen",
    "min": null,
    "max": null
  },
  {
    "id": "instrument.fart_kn",
    "signalk": "navigation.speedOverGround",
    "enhet": "kn",
    "beskrivning": "Farten över grund",
    "min": 0,
    "max": 100
  },
  {
    "id": "instrument.kurs_grader",
    "signalk": "navigation.courseOverGroundTrue",
    "enhet": "°",
    "beskrivning": "Kursen över grund",
    "min": 0,
    "max": 360
  },
  {
    "id": "instrument.djup_m",
    "signalk": "environment.depth.belowTransducer",
    "enhet": "m",
    "beskrivning": "Djupet",
    "min": 0,
    "max": 1000
  },
  {
    "id": "instrument.vind_ms",
    "signalk": "environment.wind.speedApparent",
    "enhet": "m/s",
    "beskrivning": "Vinden (skenbar)",
    "min": 0,
    "max": 80
  },
  {
    "id": "instrument.vind_vinkel",
    "signalk": "environment.wind.angleApparent",
    "enhet": "°",
    "beskrivning": "Vindens vinkel mot fören",
    "min": -180,
    "max": 360
  },
  {
    "id": "vatten.temp",
    "signalk": "environment.water.temperature",
    "enhet": "°C",
    "beskrivning": "Vattnets temperatur",
    "min": -5,
    "max": 40
  },
  {
    "id": "motor.varvtal",
    "signalk": "propulsion.*.revolutions",
    "enhet": "rpm",
    "beskrivning": "Varvtal",
    "min": 0,
    "max": 10000
  },
  {
    "id": "motor.kylvatten_temp",
    "signalk": "propulsion.*.coolantTemperature",
    "enhet": "°C",
    "beskrivning": "Kylvattnets temperatur",
    "min": -40,
    "max": 150
  },
  {
    "id": "motor.oljetryck",
    "signalk": "propulsion.*.oilPressure",
    "enhet": "kPa",
    "beskrivning": "Oljetryck",
    "min": 0,
    "max": 2000
  },
  {
    "id": "motor.timmar",
    "signalk": "propulsion.*.runTime",
    "enhet": "h",
    "beskrivning": "Gångtimmar",
    "min": 0,
    "max": 100000
  },
  {
    "id": "motor.bransle",
    "signalk": "propulsion.*.fuel.rate",
    "enhet": "l/h",
    "beskrivning": "Bränsleflöde",
    "min": 0,
    "max": 1000
  },
  {
    "id": "motor.laddning",
    "signalk": "propulsion.*.alternatorVoltage",
    "enhet": "V",
    "beskrivning": "Generatorns spänning på motorn",
    "min": 0,
    "max": 60
  },
  {
    "id": "motor.last",
    "signalk": "propulsion.*.engineLoad",
    "enhet": "%",
    "beskrivning": "Motorns last",
    "min": 0,
    "max": 125
  },
  {
    "id": "motor.status",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Motorns varningar (127489)",
    "min": null,
    "max": null
  },
  {
    "id": "motor.tripp_liter",
    "signalk": "propulsion.*.fuel.used",
    "enhet": "l",
    "beskrivning": "Bränslet under resan, enligt motorn",
    "min": 0,
    "max": 100000
  },
  {
    "id": "bat.trim",
    "signalk": "navigation.attitude.pitch",
    "enhet": "°",
    "beskrivning": "Trimmen",
    "min": -90,
    "max": 90
  },
  {
    "id": "bat.slagsida",
    "signalk": "navigation.attitude.roll",
    "enhet": "°",
    "beskrivning": "Slagsidan",
    "min": -180,
    "max": 180
  },
  {
    "id": "bat.kurs",
    "signalk": "navigation.headingMagnetic",
    "enhet": "°",
    "beskrivning": "Kursen",
    "min": 0,
    "max": 360
  },
  {
    "id": "bat.girhastighet",
    "signalk": "navigation.rateOfTurn",
    "enhet": "°/s",
    "beskrivning": "Girhastigheten",
    "min": -180,
    "max": 180
  },
  {
    "id": "autopilot.lage",
    "signalk": "steering.autopilot.state",
    "enhet": "",
    "beskrivning": "Autopilotens läge",
    "min": null,
    "max": null
  },
  {
    "id": "autopilot.kurs",
    "signalk": "steering.autopilot.target.headingMagnetic",
    "enhet": "°",
    "beskrivning": "Autopilotens kurs",
    "min": 0,
    "max": 360
  },
  {
    "id": "tripp.nm_till_tom",
    "signalk": null,
    "enhet": "NM",
    "beskrivning": "Sjömil till tom tank, enligt motorn",
    "min": 0,
    "max": 10000
  },
  {
    "id": "tank.niva",
    "signalk": "tanks.*.*.currentLevel",
    "enhet": "%",
    "beskrivning": "Tankens nivå",
    "min": 0,
    "max": 100
  },
  {
    "id": "tank.kapacitet",
    "signalk": "tanks.*.*.capacity",
    "enhet": "l",
    "beskrivning": "Tankens volym enligt tankgivaren",
    "min": 0,
    "max": 20000
  },
  {
    "id": "lanspump.gar",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Länspumpen går (bara läsning)",
    "min": null,
    "max": null
  },
  {
    "id": "kabin.temp",
    "signalk": "environment.inside.temperature",
    "enhet": "°C",
    "beskrivning": "Temperaturen i kabinen",
    "min": -40,
    "max": 70
  },
  {
    "id": "kabin.fukt",
    "signalk": "environment.inside.relativeHumidity",
    "enhet": "%",
    "beskrivning": "Fukten i kabinen",
    "min": 0,
    "max": 100
  },
  {
    "id": "motorrum.temp",
    "signalk": "environment.inside.engineRoom.temperature",
    "enhet": "°C",
    "beskrivning": "Temperaturen i motorrummet",
    "min": -40,
    "max": 100
  },
  {
    "id": "ute.temp",
    "signalk": "environment.outside.temperature",
    "enhet": "°C",
    "beskrivning": "Utetemperaturen",
    "min": -50,
    "max": 60
  },
  {
    "id": "ute.fukt",
    "signalk": "environment.outside.relativeHumidity",
    "enhet": "%",
    "beskrivning": "Fukten ute",
    "min": 0,
    "max": 100
  },
  {
    "id": "vader.vind",
    "signalk": "environment.wind.speedTrue",
    "enhet": "m/s",
    "beskrivning": "Vinden",
    "min": 0,
    "max": 80
  },
  {
    "id": "vader.byvind",
    "signalk": null,
    "enhet": "m/s",
    "beskrivning": "Byarna",
    "min": 0,
    "max": 100
  },
  {
    "id": "vader.riktning",
    "signalk": "environment.wind.directionTrue",
    "enhet": "°",
    "beskrivning": "Vindens riktning",
    "min": 0,
    "max": 360
  },
  {
    "id": "vader.regn",
    "signalk": null,
    "enhet": "mm/h",
    "beskrivning": "Regnet nu",
    "min": 0,
    "max": 500
  },
  {
    "id": "vader.regn_dygn",
    "signalk": null,
    "enhet": "mm",
    "beskrivning": "Regnet i dag",
    "min": 0,
    "max": 2000
  },
  {
    "id": "vader.tryck",
    "signalk": "environment.outside.pressure",
    "enhet": "hPa",
    "beskrivning": "Lufttrycket",
    "min": 800,
    "max": 1100
  },
  {
    "id": "jord.fukt",
    "signalk": null,
    "enhet": "%",
    "beskrivning": "Jordfukten",
    "min": 0,
    "max": 100
  },
  {
    "id": "givare.batteri",
    "signalk": null,
    "enhet": "V",
    "beskrivning": "Givarens batteri",
    "min": 0,
    "max": 5
  },
  {
    "id": "givare.batteri_procent",
    "signalk": null,
    "enhet": "%",
    "beskrivning": "Givarens batteri",
    "min": 0,
    "max": 100
  },
  {
    "id": "kyl.temp",
    "signalk": "environment.inside.refrigerator.temperature",
    "enhet": "°C",
    "beskrivning": "Kylskåpet",
    "min": -30,
    "max": 30
  },
  {
    "id": "frys.temp",
    "signalk": "environment.inside.freezer.temperature",
    "enhet": "°C",
    "beskrivning": "Frysen",
    "min": -50,
    "max": 20
  },
  {
    "id": "hus.inne.temp",
    "signalk": "environment.inside.temperature",
    "enhet": "°C",
    "beskrivning": "Temperaturen inne",
    "min": -40,
    "max": 60
  },
  {
    "id": "hus.ute.temp",
    "signalk": "environment.outside.temperature",
    "enhet": "°C",
    "beskrivning": "Utetemperaturen",
    "min": -50,
    "max": 60
  },
  {
    "id": "hus.fukt",
    "signalk": "environment.inside.relativeHumidity",
    "enhet": "%",
    "beskrivning": "Fukten inne",
    "min": 0,
    "max": 100
  },
  {
    "id": "hus.vattenlacka",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Vattenläcka",
    "min": null,
    "max": null
  },
  {
    "id": "hus.effekt",
    "signalk": null,
    "enhet": "W",
    "beskrivning": "Effekten",
    "min": 0,
    "max": 100000
  },
  {
    "id": "hus.energi",
    "signalk": null,
    "enhet": "kWh",
    "beskrivning": "Energin, mätarställningen",
    "min": 0,
    "max": null
  },
  {
    "id": "hus.dorr",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Dörren är öppen",
    "min": null,
    "max": null
  },
  {
    "id": "hus.fonster",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Fönstret är öppet",
    "min": null,
    "max": null
  },
  {
    "id": "hus.las",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Låset är låst",
    "min": null,
    "max": null
  },
  {
    "id": "hus.larm",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Larmets läge",
    "min": null,
    "max": null
  },
  {
    "id": "hus.rok",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Brandvarnaren larmar",
    "min": null,
    "max": null
  },
  {
    "id": "hus.zon.temp",
    "signalk": null,
    "enhet": "°C",
    "beskrivning": "Zonens temperatur",
    "min": -40,
    "max": 60
  },
  {
    "id": "hus.zon.lage",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Zonens läge",
    "min": null,
    "max": null
  },
  {
    "id": "nobo.kontakt",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Kontakten med Nobø-hubben",
    "min": null,
    "max": null
  },
  {
    "id": "batteri.effekt",
    "signalk": "electrical.batteries.*.power",
    "enhet": "W",
    "beskrivning": "Batteriets effekt",
    "min": -50000,
    "max": 50000
  },
  {
    "id": "batteri.tid_kvar",
    "signalk": "electrical.batteries.*.capacity.timeRemaining",
    "enhet": "h",
    "beskrivning": "Tiden kvar med strömmen nu",
    "min": 0,
    "max": 1100
  },
  {
    "id": "landstrom.strom",
    "signalk": "electrical.ac.*.phase.A.current",
    "enhet": "A",
    "beskrivning": "Landströmmens ström",
    "min": 0,
    "max": 100
  },
  {
    "id": "landstrom.effekt",
    "signalk": "electrical.ac.*.phase.A.realPower",
    "enhet": "W",
    "beskrivning": "Landströmmens effekt",
    "min": 0,
    "max": 25000
  },
  {
    "id": "ac.kalla",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Varifrån 230 V kommer",
    "min": null,
    "max": null
  },
  {
    "id": "ac.effekt",
    "signalk": "electrical.inverters.*.ac.realPower",
    "enhet": "W",
    "beskrivning": "Effekten på växelriktarens AC-utgång",
    "min": 0,
    "max": 25000
  },
  {
    "id": "sol.effekt",
    "signalk": "electrical.solar.*.panelPower",
    "enhet": "W",
    "beskrivning": "Solcellernas effekt",
    "min": 0,
    "max": 65534
  },
  {
    "id": "sol.skord",
    "signalk": "electrical.solar.*.yieldToday",
    "enhet": "kWh",
    "beskrivning": "Solcellernas skörd i dag",
    "min": 0,
    "max": 655
  },
  {
    "id": "sol.lage",
    "signalk": "electrical.solar.*.chargingMode",
    "enhet": "",
    "beskrivning": "Solladdarens läge",
    "min": null,
    "max": null
  },
  {
    "id": "victron.kontakt",
    "signalk": null,
    "enhet": "",
    "beskrivning": "Kontakten med Victrons GX-enhet",
    "min": null,
    "max": null
  },
  {
    "id": "tank.volym",
    "signalk": "tanks.*.*.currentVolume",
    "enhet": "l",
    "beskrivning": "Det som finns i tanken",
    "min": 0,
    "max": 20000
  },
  {
    "id": "forbrukare.utblas",
    "signalk": null,
    "enhet": "°C",
    "beskrivning": "Temperaturen vid förbrukarens utblås",
    "min": -40,
    "max": 300
  }
]
